'use client';

import { Toaster } from 'sonner';
import { ReactNode } from 'react';
import { NavigationGuardProvider } from 'next-navigation-guard';
import { type ThemeProviderProps, ThemeProvider } from 'next-themes';

// Constants
import { THEME } from '@shared/constants';

// Stores

// Context
import { WebSocketProvider } from '@/providers';
export interface ProvidersProps {
  children: ReactNode;
  themeProps?: ThemeProviderProps;
  defaultTheme?: string;
  forcedTheme?: string;
}
export const Providers = ({
  children,
  defaultTheme = THEME.LIGHT,
  forcedTheme = THEME.LIGHT,
  themeProps
}: ProvidersProps) => {
  const toasterClassName = 'lg:mt-[50px]';
  return <WebSocketProvider autoConnect={false} data-sentry-element="WebSocketProvider" data-sentry-component="Providers" data-sentry-source-file="providers.tsx">
      <ThemeProvider {...themeProps} disableTransitionOnChange attribute="class" defaultTheme={defaultTheme} forcedTheme={forcedTheme} enableSystem data-sentry-element="ThemeProvider" data-sentry-source-file="providers.tsx">
        <Toaster richColors position="top-right" closeButton duration={5000} invert visibleToasts={1} className={toasterClassName} toastOptions={{
        classNames: {
          closeButton: 'left-[unset] -right-4',
          loading: 'bg-white text-frost-900 border-none'
        }
      }} data-sentry-element="Toaster" data-sentry-source-file="providers.tsx" />
        <NavigationGuardProvider data-sentry-element="NavigationGuardProvider" data-sentry-source-file="providers.tsx">{children}</NavigationGuardProvider>
      </ThemeProvider>
    </WebSocketProvider>;
};